/** @format */
import { auth } from "firemade";

export default async function authenticate() {
  return auth.currentUser;
}
